:host {
  height: 0;
  overflow: hidden;
  position: absolute;
  top: var(--cms-negative-spacing-100);
  left: var(--cms-spacing-100);  
  padding: 0 var(--cms-spacing-100);
  z-index: 999;
}

:host(:focus-within) {
  height: auto;
  background-color: var(--cms-semanticColors-container-weak-background);
  border-radius: var(--cms-border-radius-sm);
  border-width: var(--cms-border-size-sm);
  border-color: var(--cms-semanticColors-container-strong-border);
  border-style: solid;
}

.link {
  /* disable border, bbecause we provide our own focus style */
  --cms-link-focus-border-width: 0;
}